import Cookies from "js-cookie";

const ErrorMessage = "errorMessage";

export function getErrorMessage() {
  return Cookies.get(ErrorMessage);
}

export function setErrorMessage(error) {
  return Cookies.set(ErrorMessage, error);
}

export function removeErrorMessage() {
  return Cookies.remove(ErrorMessage);
}
